import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useTheme } from '../hooks/useTheme';

export function SidebarLogo({ collapsed = false, mobile = false, onClick, asLink = true }) {
  const { isDark } = useTheme();
  const Wrapper = asLink ? Link : 'div';
  const wrapperProps = asLink ? { to: '/dashboard' } : {};
  return (
    <Wrapper
      {...wrapperProps}
      onClick={onClick}
      className={`sidebar-logo ${collapsed ? 'collapsed' : ''} ${mobile ? 'mobile' : ''}`}
      aria-label="FuelCyclePro dashboard"
    >
      <Logo
        size={collapsed ? 22 : 32}
        showText
        shortText={collapsed}
        textClass="text-base"
        variant={isDark ? 'dark' : 'color'}
        animated={false}
      />
    </Wrapper>
  );
}

export default SidebarLogo;
